
import { mapState } from 'vuex'

import LocationAddressInfo from '../../components/locations/search/elements/AddressInfo.vue'
import LocationPhoneInfo from '../../components/locations/search/elements/PhoneInfo.vue'

export default {
  name: 'CityLocations',
  components: { LocationAddressInfo, LocationPhoneInfo },
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      states: state => state.locations.all
    }),
    locations() {
      const stateFound = this.states.find(s => s.code === this.blok.state)
      if (!stateFound) {
        return []
      }

      const cityFound = stateFound.cities.find(c => c.name === this.blok.city)
      if (cityFound) {
        return cityFound.locations
      }

      console.error('** No locations found', this.blok.state, this.blok.city)
      return []
    },
  },
}
